import { toast } from "react-toastify";

import eyeIcon from "../../../assets/icons/eyeicon.svg";
import { transactionStateOptions, transactionTerminalOptions } from "../../../lib/constants";
import { useUpdateTransactionVerified } from "../../../lib/queries/queriesAndMutations";
import { fomatCardNumber, unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import CopyButton from "../../shared/CopyButton";
import SettlmentTooltipBtn from "../../shared/SettlmentTooltipBtn";
import ValueFinder from "../../shared/ValueFinder";
import VerfiedTooltipBtn from "../../shared/VerfiedTooltipBtn";
import AlertButton from "../../ui/AlertButton";

const TrasnactionCard = ({ item, navigate, refetch }) => {
  const { mutateAsync: verifyTransaction } = useUpdateTransactionVerified();

  const { amount, transaction_state, settlement_status, verified_by_user, order_number } = item.transaction;

  const trackingCode = item?.transaction?.vanda_tracking_code;

  const transactionTime =
    item.type === "pos" ? item?.additional_data?.payment_time : item.transaction.invoice_time;

  const handleVerifiedTransaction = async () => {
    try {
      const response = await verifyTransaction(trackingCode);
      if (response.status === 200) {
        toast.success("تراکنش مورد تایید کاربر گردید");
        refetch();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="bg-primary-10 py-2 px-4 rounded-[16px] flex flex-col gap-1  items-center shadow-lg border  ">
      <div className="flex justify-between items-center w-full   ">
        <div className=" flex-center items-top gap-1  text-dark  ">
          <p>تراکنش </p>
          <ValueFinder data={transactionTerminalOptions} title={item.type} />
          <span>{item.title ?? "-"}</span>
        </div>
        <button
          onClick={() => navigate(`/transaction/info/${trackingCode}`)}
          className="flex flex-col w-fit justify-center items-center whitespace-nowrap  hover:bg-primary-100 px-1 my-1 text-dark rounded-md disabled:bg-secondary-30 disabled:text-black"
        >
          <img src={eyeIcon} alt="editIcon" className="white-img bg-neutral-20 rounded-full " />
        </button>
      </div>

      <div className="mt-2  flex flex-col gap-1 items-center w-full text-[14px]">
        <div className="flex justify-between items-center gap-2 w-full ">
          <label className="text-[12px]" htmlFor="">
            شماره پیگیری وندا
          </label>

          <div className="text-center align-middle flex-center ">
            <CopyButton copyText={trackingCode ?? "-"} />
            {trackingCode ?? "-"}
          </div>
        </div>

        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            مبلغ (ریال)
          </label>
          {amount.toLocaleString() ?? "-"}
        </div>
        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            تاریخ پرداخت
          </label>
          <div className="flex ">
            <div>{unixToPersianDay(transactionTime) ?? "-"}</div>-
            <div>{unixToPersianTime(transactionTime) ?? "-"}</div>
          </div>
        </div>
        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            شماره سفارش کاربر
          </label>
          <div className="flex-center h-full text-center align-middle  ">
            <CopyButton copyText={order_number ?? "-"} />
            <span>{order_number ?? "-"}</span>
          </div>
        </div>
        <div className="flex justify-between items-center gap-2 w-full">
          <label className="text-[12px]" htmlFor="">
            شماره کارت
          </label>
          <div className="text-center align-middle" dir="ltr">
            {fomatCardNumber(item?.additional_data?.card_number)}
          </div>
        </div>
      </div>
      <hr className="bg-neutral-20 h-[2px] text-neutral-20 w-full" />
      <div className="flex gap-2 mt-auto flex-col w-full ">
        <div className="flex justify-end gap-2 items-center w-full ">
          <div className="flex  items-center gap-2">
            <ValueFinder data={transactionStateOptions} title={transaction_state} />
            {transaction_state === "success" && (
              <>
                <SettlmentTooltipBtn value={settlement_status} />
                {verified_by_user ? (
                  <VerfiedTooltipBtn value={verified_by_user} />
                ) : (
                  <AlertButton
                    onClick={handleVerifiedTransaction} // Stop propagation here
                    className="w-12 h-12 hover:bg-primary-70 text-white"
                    refetch={refetch}
                  >
                    <VerfiedTooltipBtn value={verified_by_user} />
                  </AlertButton>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default TrasnactionCard;
